module.exports = __webpack_public_path__ + "static/adeyemo-5ffc9f2fb18e1c73ddfc5e6cd08ef968.png";